import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'PaidTiersCard';
export const classes = {
	card: `${PREFIX}-card`,
	cardHeader: `${PREFIX}-cardHeader`,
	cardBody: `${PREFIX}-cardBody`,
	cardFooter: `${PREFIX}-cardFooter`,
	tierTitle: `${PREFIX}-tierTitle`,
	btn: `${PREFIX}-btn`,
};
export const StyledGrid = styled(Grid)(({ theme }) => ({
	[`& .${classes.card}`]: {
		width: '100%',
		height: 275,
	},
	[`& .${classes.cardHeader}`]: {
		width: 'auto',
		textAlign: 'center',
		marginLeft: '20px',
		marginRight: '20px',
		marginTop: '-40px',
		padding: '20px 0',
	},
	[`& .${classes.cardBody}`]: {
		[theme.breakpoints.only('md')]: {
			overflowY: 'scroll',
		},
	},
	[`& .${classes.cardFooter}`]: {
		marginTop: -theme.spacing(1),
		paddingBottom: theme.spacing(1),
		border: '0',
		borderRadius: '6px',
		justifyContent: 'center !important',
		marginBottom: theme.spacing(1),
	},
	[`& .${classes.tierTitle}`]: {
		marginTop: '1rem',
		textAlign: 'center',
		padding: '0',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	[`& .${classes.btn}`]: {
		color: '#8e24aa',
		border: '1px solid #8e24aa',
		marginTop: theme.spacing(-1),
	},
}));
